<div class="tab-pane" role="tabpanel" id="corvi">
    <fieldset id="agregar_corvi" class="">
        <div class="step_section">
            <form [formGroup]="form">
                <div class="row" id="row">

                    <div class="col-md-12" id="content">
                        <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                            <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                            <span id="tp_dir_message"></span>
                        </div>
                        <div class="form-horizontal">
                            <div class="form-group" align="left">
                                <div class="col-md-3">
                                    <label for="corvi" style="padding-top: 15px">FECHA</label>
                                </div>
                                <div class="col-md-3" align="left">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <span><input matInput disabled formControlName="fecha">{{fecha}}</span>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3">
                                    <label for="corvi" style="padding-top: 15px">CORVI</label>
                                </div>
                                <div class="col-md-3" align="left">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <span><input matInput disabled formControlName="corvi">{{corvi}}</span>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </fieldset>
</div>
<div class="separator"></div>